import { SxProps } from '@mui/material';
import { theme } from '@portals/core/src/themes/immobilien/main';

export const styles: Record<string, SxProps> = {
  stack: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: '6px',
    height: '100%',
  },
  stackDivider: {
    '&:last-of-type': {
      display: 'none',
    },
  },
  stackElement: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 3,
    p: 5,
  },
  stackElementvalue: {
    textAlign: 'right',
  },
  deleteButtonContainer: {
    mt: 'auto',
  },
  deleteButton: {
    borderRadius: '100%',
    borderColor: theme.palette.grey[400],
    transition: 'border-color 250ms cubic-bezier(0.4, 0, 0.2, 1)',
    p: { lg: '14px' },
    '& svg': {
      height: { xs: '18px', lg: '24px' },
      width: { xs: '18px', lg: '24px' },
    },
    '&:hover': {
      borderColor: theme.palette.grey[900],
      bgcolor: theme.palette.button.secondary.backgroundHover,
    },
  },
};
